"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Td = exports.Th = exports.Table = exports.TableContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../styles");
var stickyColumn = function (_a) {
    var isStickyColumn = _a.isStickyColumn;
    return isStickyColumn
        ? "position: sticky;\n    left: 0;"
        : "";
};
var stickyHeader = function (_a) {
    var isStickyColumn = _a.isStickyColumn, isStickyHeader = _a.isStickyHeader;
    return isStickyHeader || isStickyColumn
        ? "\n    position: sticky;\n    top: 0;\n    left: " + (isStickyColumn ? '0' : '') + ";\n    z-index: " + (isStickyHeader && isStickyColumn ? '1' : '') + ";\n    "
        : '';
};
var TableContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return props.isOverflow
        ? "\n        overflow: auto;\n        height: 100%;\n      "
        : '';
});
exports.TableContainer = TableContainer;
var Table = styled_components_1.default.table(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-spacing: 0;\n  position: relative;\n  width: ", ";\n"], ["\n  border-spacing: 0;\n  position: relative;\n  width: ", ";\n"])), function (props) { return (props.isOverflow ? 'max-content' : ''); });
exports.Table = Table;
var Th = styled_components_1.default.th(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", ";\n\n  background-color: ", ";\n  text-align: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-size: 1.2rem;\n  padding: 1.2rem 2rem;\n\n  ", "\n"], ["\n  width: ", ";\n\n  background-color: ", ";\n  text-align: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-size: 1.2rem;\n  padding: 1.2rem 2rem;\n\n  ", "\n"])), function (props) { return props.width; }, styles_1.theme.colors.marinoBlue, function (props) { return props.textAlign || 'left'; }, styles_1.theme.colors.pureWhite, styles_1.theme.fontWeight.medium, stickyHeader);
exports.Th = Th;
var Td = styled_components_1.default.td(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: ", ";\n  padding: 1.2rem 2rem;\n\n  background-color: ", ";\n  border-top: solid 0.1rem ", ";\n\n  width: ", ";\n\n  ", "\n"], ["\n  text-align: ", ";\n  padding: 1.2rem 2rem;\n\n  background-color: ", ";\n  border-top: solid 0.1rem ", ";\n\n  width: ", ";\n\n  ", "\n"])), function (props) { return props.textAlign || 'left'; }, styles_1.theme.colors.pureWhite, styles_1.theme.colors.iceGray, function (props) { return props.width; }, stickyColumn);
exports.Td = Td;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Table.styled.js.map